import { render, staticRenderFns } from "./FamilyMessageList.vue?vue&type=template&id=ef22ef2e&lang=pug"
import script from "./FamilyMessageList.vue?vue&type=script&lang=ts"
export * from "./FamilyMessageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports